import { useEffect, useState } from "react";
import RecipeCard from "@/features/recipe/RecipeCard";
import { getCatalog } from "@/lib/catalog-client";
import type { Catalog } from "@/lib/types";

export default function RecipeListPage() {
  const [catalog, setCatalog] = useState<Catalog | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    getCatalog()
      .then((c) => {
        if (!cancelled) setCatalog(c);
      })
      .catch((e: Error) => {
        if (!cancelled) setError(e.message);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (error) {
    return (
      <section>
        <h1 className="text-2xl font-semibold">Recipes</h1>
        <p className="mt-2 text-red-700 dark:text-red-400" role="alert">
          Could not load the catalog: {error}
        </p>
      </section>
    );
  }

  if (!catalog) {
    return (
      <section>
        <h1 className="text-2xl font-semibold">Recipes</h1>
        <p className="mt-2 text-slate-500" aria-live="polite">
          Loading…
        </p>
      </section>
    );
  }

  if (catalog.recipes.length === 0) {
    return (
      <section>
        <h1 className="text-2xl font-semibold">Recipes</h1>
        <p className="mt-2 text-slate-700 dark:text-slate-300">
          No recipes published yet. Check back soon.
        </p>
      </section>
    );
  }

  return (
    <section>
      <header className="mb-4 flex items-baseline justify-between">
        <h1 className="text-2xl font-semibold">Recipes</h1>
        <p className="text-sm text-slate-500">
          {catalog.recipes.length} recipe{catalog.recipes.length === 1 ? "" : "s"}
        </p>
      </header>
      <div className="grid sm:grid-cols-2 gap-3">
        {catalog.recipes.map((r) => (
          <RecipeCard key={r.id} recipe={r} />
        ))}
      </div>
    </section>
  );
}
